import React from 'react';
import { RouteComponentProps } from '@reach/router';
import Linkify from 'react-linkify';
import { Button2, Text2, Group, HeaderText, Marquee } from '@el8/vital';
import { Box } from 'components';
import { getPracticeCancellationPolicy, getAppointmentPhone } from 'utils/practice';

import { PhysicianInfo, PracticeInfo } from 'types';
import { Appointment, AppointmentType } from 'EntityTypes';

import styles from './AppointmentManager.less';
import AppointmentDetails from './AppointmentDetails';

type Props = {
  appointment: Appointment;
  appointmentType: AppointmentType;
  physician: PhysicianInfo;
  practice: PracticeInfo;
  onCancelAppointment: () => void;
  onConfirmAppointment: () => void;
} & RouteComponentProps;

const AppointmentManager: React.FC<Props> = ({
  appointment,
  appointmentType,
  physician,
  onConfirmAppointment,
  onCancelAppointment,
  practice,
}) => {
  return (
    <Box className={styles.container} direction="column" align="center">
      <HeaderText
        align="center"
        className={styles.title}
        legacyVariant="legacyTitleText"
        sizing="heading-lg"
        tag="h1"
      >
        Your appointment is coming up
      </HeaderText>
      <AppointmentDetails
        appointment={appointment}
        appointmentType={appointmentType}
        physician={physician}
        practice={practice}
      />
      <Group style={{ marginTop: 20, width: '100%' }}>
        <Button2 onClick={onConfirmAppointment} kind="primary" label="I Will Be There" />
        {practice.features.patientCanCancel && (
          <Button2 kind="link" onClick={onCancelAppointment} label="Cancel Appointment" />
        )}
      </Group>
      <br />
      {practice.features.patientCanCancel ? (
        <Text2>
          <em>{`${getPracticeCancellationPolicy(practice)}`}</em>
        </Text2>
      ) : (
        <Text2>
          <em>
            {`To cancel or reschedule an appointment, please contact the office as soon as possible at ${getAppointmentPhone(
              appointment,
              practice,
            )}`}
          </em>
        </Text2>
      )}
      <br />
      {appointment.telehealthInstructions && (
        <Marquee className={styles.callout}>
          <HeaderText
            tag="h1"
            legacyVariant="legacyHeaderText"
            sizing="heading-sm"
          >{`Instructions for your ${
            appointment.isTelehealth ? 'virtual ' : ''
          }visit:`}</HeaderText>
          <br />
          {/* Types are wrong, className does exist on Linkify
              // @ts-ignore */}
          <Linkify className={styles.overflow} properties={{ target: '_blank' }}>
            {appointment.telehealthInstructions}
          </Linkify>
        </Marquee>
      )}
    </Box>
  );
};

export default AppointmentManager;
